import { useCallback, useEffect } from 'react';
import { isInteractiveElement } from '@bynder-studio/misc';
import { isCtrlKey } from '~/helpers/hotKeys';

const useLimitTextShortcuts = ({ toggleLimit }: { toggleLimit?: () => void }) => {
    const handleKeyDown = useCallback(
        (e: KeyboardEvent): void => {
            if (isInteractiveElement(e) || isCtrlKey(e) || e.shiftKey) {
                return;
            }

            switch (e.code) {
                case 'KeyL': {
                    toggleLimit && toggleLimit();

                    break;
                }

                default:
                    break;
            }
        },
        [toggleLimit],
    );

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
};

export default useLimitTextShortcuts;
